import { Box, Typography } from "@mui/material";
import { getStyles } from "./Counter.styles";
import { useAzureBlobData } from "../../hooks";

const Counter = () => {
  const styles = getStyles();
  const { data } = useAzureBlobData();
  const numberOfDonatedBooks = data?.donatedBooks || 0;

  return (
    <Box id="results-section"
      sx={styles.counterContainer}>
      <Box sx={styles.counterSection}>
        <Typography variant="h2" component="h2">
          Ce am reușit împreună până acum
        </Typography>
        <Box sx={styles.counterStats}>
          <Box sx={styles.counterStatItem}>
            <Typography variant="h2" component="h4">
              {data?.equippedSchools}
            </Typography>
            <Typography variant="body1" component="p">
              școli echipate
            </Typography>
          </Box>
          <Box sx={styles.counterStatItem}>
            <Typography variant="h2" component="h4">
              {data?.supportedKids}
            </Typography>
            <Typography variant="body1" component="p">
              copii susținuți
            </Typography>
          </Box>
          <Box sx={styles.counterStatItem}>
            <Typography variant="h2" component="h4">
              {data?.donatedBooks}
            </Typography>
            <Typography variant="body1" component="p">
              cărți donate
            </Typography>
          </Box>
        </Box>
        <Box sx={styles.counterImages}>
          <Box
            sx={numberOfDonatedBooks < 25000 ? styles.disabledImage : undefined}
          >
            <img src="/assets/images/25-books.svg" alt="Counter Background" />
          </Box>
          <Box
            sx={numberOfDonatedBooks < 40000 ? styles.disabledImage : undefined}
          >
            <img src="/assets/images/50-books.svg" alt="Counter Background" />
          </Box>
          <Box
            sx={
              numberOfDonatedBooks < 60000 ? styles.disabledImage : undefined
            }
          >
            <img src="/assets/images/75-books.svg" alt="Counter Background" />
          </Box>
          <Box
            sx={
              numberOfDonatedBooks < 80000 ? styles.disabledImage : undefined
            }
          >
            <img src="/assets/images/100-books.svg" alt="Counter Background" />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Counter;
